<div class="flex max-h-[80vh] min-h-[300px] flex-col">
  <div
    class="border-s200 flex flex-shrink-0 items-center gap-2 border-b px-8 py-5"
  >
    <span class="text-s1 text-lg font-medium">{{ dataItem.title }}</span>
    <span
      *ngIf="dataItem.subtitle"
      class="text-s500 min-w-0 flex-1 truncate text-lg"
      >{{ dataItem.subtitle }}</span
    >
    <button
      *ngIf="dataItem.rawOutput"
      class="ml-auto mr-8 flex-shrink-0 select-none text-base font-medium focus:outline-none"
      [ngClass]="showXml ? 'text-green-600' : 'text-s500 hover:text-s1'"
      (click)="toggleXml()"
    >
      Show XML
    </button>
  </div>

  <ng-scrollbar
    [orientation]="dataItem.wrapText === false ? 'auto' : 'vertical'"
    [visibility]="'hover'"
    [appearance]="'compact'"
    class="flex-1"
  >
    <div class="px-8 py-5">
      <ng-container *ngIf="hasInput">
        <div class="text-s500 mb-2 text-base font-medium uppercase">Input</div>
        <pre
          class="text-s600 mb-6 whitespace-pre-wrap break-words font-mono text-[16px]"
          >{{ inputDisplay }}</pre
        >
        <div class="text-s500 mb-2 text-base font-medium uppercase">Output</div>
      </ng-container>
      <pre
        class="text-s600 font-mono text-[16px]"
        [ngClass]="
          dataItem.wrapText === false
            ? 'whitespace-pre'
            : 'whitespace-pre-wrap break-words'
        "
        >{{ outputDisplay }}</pre
      >
    </div>
  </ng-scrollbar>
</div>
